import React from 'react';
import { isQldRegion } from 'utils/petFormHelpers';

const LandlordHeader: React.FC<{roleType: string}> = ({roleType}) => (
  <div className="bg-navy pt-60px pb-30px">
    <div className="w-100 max-w-960px px-30px px-lg-0 mx-auto">
      <div className="d-flex flex-column gap-10px fw-bold text-white">
        <div className="fs-25px">
          Application to keep a pet in a rental property{isQldRegion() ? " (Form 21 - QLD)" : ""}
        </div>
        <div className="fs-18px">Landlord to complete</div>
      </div>
    </div>
  </div>
);

export default LandlordHeader;
